import { useOfferFiltersState } from "../context/OfferFiltersContext";
import { useListingLocation } from "../hooks/useListingLocation";
import { useOfferFilterSubmit } from "../hooks/useOfferFilterSubmit";
import { buildClearAllUrl, getActiveFilterChips } from "../utils/activeFilters";
import ActiveFiltersChipBar from "./ActiveFiltersChipBar";
import DesktopFilterPill from "./DesktopFilterPill";
import PriceRangePicker from "./PriceRangePicker";
import SortDropdown from "./SortDropdown";
import StaticButtonGroup from "./StaticButtonGroup";
import React from "react";
export default function DesktopQuickFiltersBar() {
    const { committedState, filterConfig, facetData, pathFilters } = useOfferFiltersState();
    const submitFilters = useOfferFilterSubmit();
    const location = useListingLocation();
    function handleInstantNavigate(newState) {
        submitFilters({ state: newState });
    }
    const removableChips = getActiveFilterChips(committedState, filterConfig, facetData, pathFilters, location.pathname, location.search);
    const clearAllUrl = buildClearAllUrl(committedState, location.pathname, location.search);
    const visibleFilters = filterConfig.filter((f) => f.type !== "hidden" && f.facet_group != null);
    return (<div className="flex flex-col py-2 gap-4">
      <div className="flex items-center flex-wrap gap-2">
        {pathFilters.map((filter) => filter.type === "range" ? (<div key={filter.id} className="w-56">
              <PriceRangePicker filter={filter} onAfterChange={handleInstantNavigate}/>
            </div>) : (<div key={filter.id} className="w-56">
              <StaticButtonGroup filter={filter} onAfterChange={handleInstantNavigate}/>
            </div>))}
        {visibleFilters.map((filter) => (<DesktopFilterPill key={filter.id} filter={filter}/>))}
        <div className="ml-auto">
          <SortDropdown />
        </div>
      </div>

      <ActiveFiltersChipBar chips={removableChips} clearAllUrl={clearAllUrl} className="flex-wrap"/>
    </div>);
}
